import * as validators from '../../../../constants/validators';

export const config = {
  email: validators.email,
  password: {
    rules: [
      {
        required: true,
        message: 'Please enter your password.',
      },
    ],
  },
};
